var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoAdjustmentsWt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.753,
    height: 27.048,
    viewBox: "0 0 29.753 27.048",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_921",
    "data-name": "Path 921",
    d: "M22.638,6.057A4.057,4.057,0,1,1,26.7,10.114a4.057,4.057,0,0,1-4.057-4.057ZM2.352,7.41H18.581a1.352,1.352,0,0,0,0-2.7H2.352a1.352,1.352,0,0,0,0,2.7Zm8.114,4.057a4.057,4.057,0,0,0-3.814,2.7h-4.3a1.352,1.352,0,1,0,0,2.7h4.3a4.057,4.057,0,1,0,3.814-5.41Zm18.933,2.7H18.581a1.352,1.352,0,1,0,0,2.7H29.4a1.352,1.352,0,0,0,0-2.7ZM13.171,23.638H2.352a1.352,1.352,0,1,0,0,2.7H13.171a1.352,1.352,0,1,0,0-2.7Zm16.229,0H25.1a4.057,4.057,0,1,0,0,2.7h4.3a1.352,1.352,0,0,0,0-2.7Z",
    transform: "translate(-1 -2)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoAdjustmentsWt);
export default __webpack_public_path__ + "static/media/ico_adjustments_wt.b5c2d1a813f9137868daee6e8509199f.svg";
export { ForwardRef as ReactComponent };